import React from 'react';
import { Link } from 'react-router-dom';

const HelpPage = () => {
  return (
    <div className="legal-page">
      <div className="back-link-container">
        <Link to="/" className="back-link">&larr; Back to Home</Link>
      </div>

      <h1>Help & Support</h1>
      <p>Last Updated: [Date]</p>
      
      <h2>Frequently Asked Questions (FAQ)</h2>
      <p><strong>Q: How long does it take to generate a video?</strong><br />
      A: Generation time can vary but typically takes between 10-15 minutes. You will receive an email when your video is ready.</p>

      <p><strong>Q: What kind of input works best?</strong><br />
      A: Clear book titles or well-structured PDF manuscripts generally produce the best results. Avoid overly complex or ambiguous input.</p>

      <p><strong>Q: What are the limitations of the AI?</strong><br />
      A: The AI interprets text to generate animations. Results can sometimes be abstract or unexpected. The technology is constantly evolving. See our Policy page for more details on AI generation.</p>

      {/* Add more FAQs as needed */}

      <h2>Contact Us</h2>
      <p>If you need further assistance or encounter issues, please contact us via the methods listed on our Contact page.</p>
    </div>
  );
};

export default HelpPage; 